import { render, staticRenderFns } from "./MarketContent.vue?vue&type=template&id=4e6c6b59&scoped=true&lang=pug"
import script from "./MarketContent.vue?vue&type=script&lang=js"
export * from "./MarketContent.vue?vue&type=script&lang=js"
import style0 from "./MarketContent.vue?vue&type=style&index=0&id=4e6c6b59&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6c6b59",
  null
  
)

export default component.exports